import React from 'react';
import CheckMarker from 'oldAssets/images/icons/check-green.svg';
import PlusMarker from 'oldAssets/images/icons/plus.svg';
import styles from './ListsAndImage.module.scss';
import classNames from 'classnames';

const ListsAndImage = ({
  advantages,
  suitable,
  photo,  
  photoPosition = 'end',
  additionalClasses
}) => {
  const classes = classNames(
    styles.ListsAndImage,
    photoPosition == 'start' ? styles.revesed : '',
    additionalClasses
  );

  return (
    <div className={ classes }>
      <div className={ styles.lists }>
        { advantages && <TitleAndList { ...advantages } marker={ PlusMarker } /> }
        { suitable && <TitleAndList { ...suitable } marker={ CheckMarker } /> }
      </div>
      <figure className={ styles.image }>
        <img src={ photo } />
      </figure>
    </div>
  );
};

const TitleAndList = ({ title, list, marker }) => {
  return (
    <div className={ styles.TitleAndList }>
      <h5 className={ styles.title }>{ title }:</h5>
      <ul className={ styles.list }>
        { list && list.map(item => (
          <li className={ styles.item } key={ item }>
            <img src={ marker } className={ styles.marker } />
            <span className={ styles.text }>{ item }</span>
          </li>
        )) }
      </ul>
    </div>
  );
};

export default ListsAndImage;
